import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from 'mbs-ui-shared@services/configuration.service';
import { ErrorHandlerService } from 'mbs-ui-shared@services/error-handler.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isRmmWarehouseRequest } from './helpers/rmm-warehouse-request.helper';
import { ThrowErrorDirectlyHelper } from './helpers/throw-error-directly.helper';
import { ThrowErrorWithHandlingHelper } from './helpers/throw-error-with-handling.helper';

export const unidentifiedErrorText = 'Sorry, something went wrong';
export const invalidCredentialsText = 'The specified credentials are invalid';
export const forbiddenErrorText = "Forbidden. You don't have permission to access this";

export const MANUAL_ERROR_HANDLED = 'MANUAL_ERROR_HANDLED';
export const URL_ERROR_TYPE = 'https://mspbackups.com/errors';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private config = inject(ConfigurationService);
  private errorService = inject(ErrorHandlerService);
  private throwErrorDirectly = inject(ThrowErrorDirectlyHelper);
  private throwErrorHandling = inject(ThrowErrorWithHandlingHelper);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (isRmmWarehouseRequest(req, this.config)) return throwError(() => error);

        this.errorService.error = error;
        this.errorService.showDebugToast(error);

        if (this.errorService.isRemoteCommand(error) && this.throwErrorHandling.isDeepSyncError(error?.error || {})) {
          return throwError(() => error);
        }

        if (this.throwErrorDirectly.isThrowErrorDirectly(req, error)) {
          this.throwErrorDirectly.isLicensesError(error) && this.throwErrorHandling.handleLicenseError();

          return throwError(() => error);
        }

        this.throwErrorHandling.init(req, error);

        return throwError(() => error);
      })
    );
  }
}
